import store from "@/store/auth";
import Auth from "@/store/auth";

class Items {
  get(competitorId, name, itemDefinition, onlyFirstItem) {
    return new Promise(resolve => {
      let url = process.env.VUE_APP_API + "items/";

      let params = [];

      if (parseInt(competitorId) > 0) {
        params.push("competitorId=" + encodeURI(competitorId));
      }

      if (typeof name === "string" && name !== "") {
        params.push("name=" + encodeURI(name));
      }

      if (typeof itemDefinition === "string" && itemDefinition !== "") {
        params.push("itemDefinition=" + encodeURI(itemDefinition));
      }

      if (
        typeof onlyFirstItem === "string" &&
        (onlyFirstItem === "yes" || onlyFirstItem === "no")
      ) {
        params.push("onlyFirstItem=" + encodeURI(onlyFirstItem));
      }

      if (params.length > 0) {
        url += "?" + params.join("&");
      }

      fetch(url, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + store.getters.getJwt
        }
      }).then(response => {
        if (response.status === 200) {
          response.json().then(json => {
            resolve(json);
          });
        } else if (response.status === 401) {
          Auth.dispatch("setJwt", "").catch(err => {
            console.error(err);
            resolve(false);
          });
          resolve([]);
        }
      });
    });
  }

  getComparisonGroups(itemId) {
    return new Promise(resolve => {
      let url =
        process.env.VUE_APP_API + "items/" + itemId + "/comparison_groups/";

      fetch(url, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + store.getters.getJwt
        }
      }).then(response => {
        if (response.status === 200) {
          response.json().then(json => {
            resolve(json);
          });
        } else if (response.status === 401) {
          Auth.dispatch("setJwt", "").catch(err => {
            console.error(err);
            resolve(false);
          });
          resolve([]);
        }
      });
    });
  }

  getById(itemId) {
    return new Promise(resolve => {
      let url = process.env.VUE_APP_API + "items/" + itemId + "/";

      fetch(url, {
        method: "GET",
        headers: {
          Authorization: "Bearer " + store.getters.getJwt
        }
      }).then(response => {
        if (response.status === 200) {
          response.json().then(json => {
            resolve(json);
          });
        } else if (response.status === 401) {
          Auth.dispatch("setJwt", "").catch(err => {
            console.error(err);
            resolve(false);
          });
          resolve([]);
        }
      });
    });
  }

  update(itemId, competitorId, name, itemDefinition, onlyFirstItem) {
    return new Promise(resolve => {
      let url = process.env.VUE_APP_API + "items/" + itemId + "/";

      let data = {
        competitorId: competitorId,
        active: true,
        name: name,
        itemDefinition: itemDefinition,
        onlyFirstItem: onlyFirstItem
      };

      fetch(url, {
        method: "PUT",
        body: JSON.stringify(data),
        headers: {
          Authorization: "Bearer " + store.getters.getJwt
        }
      }).then(response => {
        if (response.status === 200) {
          response.json().then(json => {
            resolve(json.updated);
          });
        } else if (response.status === 401) {
          Auth.dispatch("setJwt", "").catch(err => {
            console.error(err);
            resolve(false);
          });
          resolve(false);
        }
      });
    });
  }

  remove(itemId) {
    return new Promise(resolve => {
      let url = process.env.VUE_APP_API + "items/" + itemId + "/";

      fetch(url, {
        method: "DELETE",
        headers: {
          Authorization: "Bearer " + store.getters.getJwt
        }
      }).then(response => {
        if (response.status === 200) {
          response.json().then(json => {
            resolve(json.deleted);
          });
        } else if (response.status === 401) {
          Auth.dispatch("setJwt", "").catch(err => {
            console.error(err);
            resolve(false);
          });
          resolve(false);
        }
      });
    });
  }
}

export default new Items();
